module.exports = __webpack_public_path__ + "static/media/image_33.1cdc69f8.png";